import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]
  static values = { copiedLabel: String }

  #originalLabel
  #resetTimeout

  async copy() {
    await navigator.clipboard.writeText(this.sourceTarget.value)

    if (!this.hasButtonTarget) return

    this.#originalLabel ??= this.buttonTarget.textContent
    this.buttonTarget.textContent = this.copiedLabelValue
    clearTimeout(this.#resetTimeout)
    this.#resetTimeout = setTimeout(() => {
      this.buttonTarget.textContent = this.#originalLabel
    }, 2000)
  }

  disconnect() {
    clearTimeout(this.#resetTimeout)
  }
}
